
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"fill":"#0072CE","d":"M0 512h512V0H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M321 379h19v76h17v-76h19v-7h-55v7zm82 0h19v76h17v-76h19v-7h-55v7zm-152 47l9-27 9 27h-18zm27 29h18l-26-83h-11l-29 83h11l8-22h22l7 22zM428 64c11 0 18 15 18 34s-6 34-17 34h-6V64h5zm-23-7v83h26c21 0 32-16 32-42s-11-41-32-41h-26zM260 98V64h4c10 0 14 7 14 17 0 12-5 17-14 17h-4zm40 42l-18-37c9-4 13-10 13-22 0-16-10-24-30-24h-23v83h18v-34h5l17 34h18zM116 57l-11 46-10-46h-9l-11 46-10-46H47l20 83h9l10-47 11 47h9l19-83h-9zm216 240h17v-41h29v-7h-29v-27h34v-8h-51v83zm-153-6c-7 0-13-7-13-35s6-35 13-35c8 0 13 7 13 35s-5 35-13 35zm32-35c0-14-3-25-9-32s-13-11-23-11c-9 0-16 4-22 11s-10 18-10 32c0 13 4 25 10 32s13 10 22 10c10 0 17-3 23-10s9-19 9-32zM97 410H74v-38H57v83h17v-38h23v38h17v-83H97v38zm106-38l-20 35-19-35h-19l25 44v39h17v-38l24-45h-8zm177-240h-31V57h-17v83h48v-8zm-201 1c-7 0-13-6-13-35 0-28 6-35 13-35 8 0 13 7 13 35 0 29-5 35-13 35zm32-35c0-13-3-25-9-32s-13-10-23-10c-9 0-16 3-22 10s-10 19-10 32c0 14 4 25 10 32s13 11 22 11c10 0 17-4 23-11s9-18 9-32z"}})])])
          )
        }
      }
    